<template>
    <ul class="navigation-links">
        <router-link to="/orders" tag="li">
          <a>
            {{ $t('orders') }}
          </a>
        </router-link>
        <router-link to="/menus" tag="li">
          <a>
            {{ $t('menus') }}
          </a>
        </router-link>
        <li>
            <span class="label-only">
                {{ $t('reports') }} <font-awesome-icon class="d-none d-md-inline-block" :icon="['fal', 'angle-down']"/>
            </span>
            <ul>
                <router-link to="/reports/product-sales" tag="li"><a>{{ $t('product_sales') }}</a></router-link>
            </ul>
        </li>
        <li>
          <a target="_blank" rel="noopener" :href="`https://${authCompany.code}.cardapio.app.br`">
            {{ $t('visit_website') }}
          </a>
        </li>
        <li v-if="false">
            <span class="label-only">
                Menu <font-awesome-icon class="d-none d-md-inline-block" :icon="['fal', 'angle-down']"/>
            </span>
            <ul>
                <router-link to="/menus" tag="li"><a>{{ $t('menus') }}</a></router-link>
                <router-link to="/products" tag="li"><a>{{ $t('products') }}</a></router-link>
                <li>
                    <a target="_blank" rel="noopener" href="https://menu.so/acaiconcept">
                        {{ $t('visit_website') }}
                    </a>
                </li>
            </ul>
        </li>
        <li class="spacer"></li>
        <li>
            <span class="label-only">
                <font-awesome-icon class="d-none d-md-inline-block" :icon="['fal', 'cog']"/>
                <span class="d-md-none">{{ $t('settings') }}</span>
            </span>
            <ul class="right">
              <router-link to="/general-settings" tag="li"><a>{{ $t('general_settings') }}</a></router-link>
              <router-link :to="`/stores`" tag="li"><a>{{ $t('manage_stores') }}</a></router-link>
              <router-link to="/printer-settings" tag="li"><a>{{ $t('printer_settings') }}</a></router-link>
              <router-link to="/staff-members" tag="li"><a>{{ $t('manage_staff') }}</a></router-link>
              <router-link v-if="false" to="/roles" tag="li"><a>{{ $t('manage_roles') }}</a></router-link>
            </ul>
        </li>
        <li>
            <span class="label-only">
                <font-awesome-icon class="d-none d-md-inline-block" :icon="['fal', 'user']"/>
                <span class="d-md-none">{{ $t('user') }}</span>
            </span>
            <ul class="right">
                <li><span class="label-only">{{authCompany.name}}</span></li>
                <li><span class="label-only">{{authStaffMember.username}}</span></li>
                <li class="divider"></li>
                <router-link :to="`/staff-members/${authStaffMember.id}`" tag="li">
                    <a>{{ $t('my_data') }}</a>
                </router-link>
                <router-link to="/auth/logout" tag="li"><a>{{ $t('logout') }}</a></router-link>
            </ul>
        </li>
        <li><a :href="`https://api.whatsapp.com/send?phone=5581996826090&text=${encodeURIComponent('Preciso de suporte, meu código da empresa e nome de usuário são: ' + authCompany.code + '/' + authStaffMember.username)}`" target="_blank">{{ $t('help') }}</a></li>
    </ul>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: "navigation-links",
        i18nOptions: {namespaces: ['navigation']},
        computed: {
            ...mapGetters(['authCompany', 'authStore', 'authStaffMember'])
        },
    }
</script>
